function isEnglishLocale(locale) {
  return locale && String(locale).toLowerCase().startsWith('en');
}

export function hasBusinessCategory(item) {
  return !!(item && (item.category || '').trim());
}

/** 仅保留已填写导航分类的业务项 */
export function filterCategorizedBusinessList(list) {
  return (list || []).filter(hasBusinessCategory);
}

function getGroupTitle(item, locale) {
  const category = (item.category || '').trim();
  if (isEnglishLocale(locale)) {
    return (item.categoryEn || '').trim() || category;
  }
  return category;
}

/**
 * 按 category 名称聚合，保持接口返回顺序；未填分类的不展示
 */
export function buildBusinessGroups(list, locale) {
  const map = new Map();
  const order = [];

  filterCategorizedBusinessList(list).forEach((item) => {
    const key = (item.category || '').trim();
    if (!map.has(key)) {
      map.set(key, {
        title: getGroupTitle(item, locale),
        list: []
      });
      order.push(key);
    }
    map.get(key).list.push(item);
  });

  return order.map((key) => map.get(key));
}



// WEBPACK FOOTER //
// ./src/utils/businessCategory.js